export function br2nl(text: string) {
  return text.replace(/<br\s*[/]?>/gi, '\n')
}

export function nl2br(text: string) {
  return text.replace(/\n/g, '<br />')
}
